import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
class EdCardsLoadingComponent extends Vue {

  public cards: number = 0;

  /* Hooks */
  created() {
    this.cards = Math.floor(window.innerWidth / 180);
  }

}

export default Vue.component('ed-cards-loading', EdCardsLoadingComponent);